import React from "react";
import {
  Form,
  Input,
  Button,
  InputNumber,
  Select,
  Space,
  Typography,
  Divider,
} from "antd";
import { DollarOutlined } from "@ant-design/icons";

const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const MacaronPaymentForm = ({ subscription, onFinish, onCancel, loading = false }) => {
  const [form] = Form.useForm();

  // Set initial values
  React.useEffect(() => {
    form.setFieldsValue({
      amount: 0,
      payment_method: "cash",
      reference_number: "",
      description: "Frais de changement de macaron",
    });
  }, [form]);

  // Watch for payment method changes to show/hide reference field
  const paymentMethod = Form.useWatch("payment_method", form);

  const handleFinish = (values) => {
    onFinish({
      ...values,
      subscription_id: subscription.id,
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      initialValues={{
        amount: 0,
        payment_method: "cash",
        description: "Frais de changement de macaron",
      }}
    >
      <div className="mb-4">
        <Text strong>Abonnement:</Text> {subscription.contract_number}
      </div>

      <div className="mb-4">
        <Text strong>Client:</Text> {subscription.client?.first_name} {subscription.client?.last_name || subscription.client?.company_name}
      </div>

      <div className="mb-4">
        <Text strong>Véhicule:</Text> {subscription.vehicle?.matricule || "Non défini"}
      </div>

      <Divider />

      <Form.Item
        name="amount"
        label="Montant des frais de macaron"
        rules={[
          { required: true, message: "Veuillez entrer le montant" },
          {
            type: "number",
            min: 0.01,
            message: "Le montant doit être supérieur à 0",
          },
        ]}
      >
        <InputNumber
          prefix={<DollarOutlined />}
          className="w-full"
          min={0.01}
          step={0.01}
          placeholder="0.00"
        />
      </Form.Item>

      <Form.Item
        name="description"
        label="Description"
        rules={[
          { required: true, message: "Veuillez entrer une description" },
        ]}
      >
        <TextArea
          rows={3}
          placeholder="Description des frais de macaron..."
        />
      </Form.Item>

      <Form.Item
        name="payment_method"
        label="Méthode de paiement"
        rules={[
          {
            required: true,
            message: "Veuillez sélectionner une méthode de paiement",
          },
        ]}
      >
        <Select>
          <Option value="cash">Espèces</Option>
          <Option value="card">Carte bancaire</Option>
          <Option value="bank_transfer">Virement bancaire</Option>
          <Option value="cheque">Chèque</Option>
        </Select>
      </Form.Item>

      {paymentMethod && paymentMethod !== "cash" && (
        <Form.Item
          name="reference_number"
          label="Numéro de référence"
          rules={[
            {
              required: true,
              message: "Veuillez entrer le numéro de référence",
            },
          ]}
        >
          <Input placeholder="Ex: TR-123456" />
        </Form.Item>
      )}

      <Form.Item className="mb-0">
        <Space className="w-full flex justify-end">
          <Button onClick={onCancel} disabled={loading}>Annuler</Button>
          <Button type="primary" htmlType="submit" loading={loading} disabled={loading}>
            Traiter le paiement des frais de macaron
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default MacaronPaymentForm;
